module.exports = {
      id: "apple-store-usage",
      viewBox: "0 0 132 40",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#apple-store",
      toString: function () {
        return this.url;
      }
    }